import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
Modal.setAppElement('#root'); // Para accesibilidad del modal

const CapacityModal = ({ isOpen, onClose, onSave, sedes }) => {
    const [selectedSede, setSelectedSede] = useState('');
    const [selectedSedeName, setSelectedSedeName] = useState('');
    const [formData, setFormData] = useState({
        group: '',
        concept: '',
        quantity: ''
    });

    const groupOptions = [
        { value: 'ambulancias', label: 'Ambulancias' },
        { value: 'camas', label: 'Camas' },
        { value: 'camillas', label: 'Camillas' },
        { value: 'consultorios', label: 'Consultorios' },
        { value: 'salas', label: 'Salas' },
        { value: 'sillas', label: 'Sillas' },
        { value: 'unidad_movil', label: 'Unidad Móvil' },
    ];

    const conceptOptions = {
        ambulancias: [
            'Básica', 'Especializada'
        ],
        camas: [
            'Pediátrica', 'Adultos', 'Obstetricia', 'Cuidado intermedio neonatal', 'Cuidado intensivo neonatal',
            'Cuidado intermedio pediátrico', 'Cuidado intensivo pediátrico', 'Cuidado intermedio adulto',
            'Cuidado intensivo adulto', 'Unidad de quemados adulto', 'Psiquiatría', 'Farmacodependencia',
            'Unidad de quemados pediátrico', 'Cuidado agudo mental', 'Cuidado intermedio mental', 'Institución paciente crónico',
            'Transplante de progenitores hematopoyeticos', 'Cuidado básico neonatal', 'Salud mental', 'TPR',
            'Salud mental adulto', 'Salud mental pediátrico', 'Paciente crónico con ventilador',
            'Paciente crónico sin ventilador', 'SPA adultos', 'SPA pediátricas', 'SPA básico adultos',
            'SPA básico pediátricos', 'Incubadora intermedia neonatal', 'Intermedia pediátrica',
            'Intermedia adultos', 'Incubadora intensiva neonatal', 'Intensiva pediátrica', 'Intensiva adultos',
            'Incubadora básico neonatal', 'Cuna intensiva neonatal', 'Cuna intensiva pediátrica',
            'Intensiva quemado adulto', 'Cuna básico neonatal', 'Intensiva quemado pediátrica', 'Atención del parto'
        ],
        camillas: [
            'Observación pediátrica', 'Salud mental', 'SPA', 'Otras patologías',
            'Observación adultos hombres', 'Observación adultos mujeres'
        ],
        consultorios: ['Urgencias', 'Consulta externa'],
        salas: ['Quirófano', 'Partos', 'Procedimientos', 'Sala de cirugía', 'Sala de radioterapia'],
        sillas: [
            'Sillas de quimioterapia', 'Sillas de hemodiálisis', 'Salud mental', 'SPA',
            'Otras patologías', 'Ambiente de transición urgencias'
        ],
        unidad_movil: ['Unidad móvil'],
    };

    useEffect(() => {
        // Actualiza el nombre de la sede cuando cambia el código de la sede
        const selected = sedes.find(sede => sede.code === selectedSede);
        setSelectedSedeName(selected ? selected.name : '');
    }, [selectedSede, sedes]);

    const handleSedeChange = (e) => {
        setSelectedSede(e.target.value);
    };

    const handleCapacityChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (selectedSede) {
            onSave({ ...formData, sedeCode: selectedSede, sedeName: selectedSedeName });
            setFormData({
                group: '',
                concept: '',
                quantity: ''
            });
            setSelectedSede('');
            setSelectedSedeName('');
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="w-[60%] mx-auto bg-white p-6 rounded-lg shadow-lg text-center border border-[#6e787aff] focus:outline-none"
            overlayClassName="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-[10]"
        >
            <h2 className="text-2xl text-left text-[#205087ff] font-bold mb-4">Agregar capacidad</h2>
            <form onSubmit={handleSubmit}>
                <div className="text-left grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="form-group">
                        <label className="form-label">Sede</label>
                        <select
                            name="sede"
                            value={selectedSede}
                            onChange={handleSedeChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona una sede</option>
                            {sedes.map(sede => (
                                <option key={sede.code} value={sede.code}>
                                    {sede.name} - {sede.departmentName} - {sede.City || sede.mainCity}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label className="form-label">Grupo</label>
                        <select
                            name="group"
                            value={formData.group}
                            onChange={handleCapacityChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona un grupo</option>
                            {groupOptions.map(group => (
                                <option key={group.value} value={group.value}>{group.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label className="form-label">Concepto</label>
                        <select
                            name="concept"
                            value={formData.concept}
                            onChange={handleCapacityChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona un concepto</option>
                            {conceptOptions[formData.group]?.map((concept, index) => (
                                <option key={index} value={concept}>{concept}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label className="form-label">Cantidad</label>
                        <input
                            type="number"
                            name="quantity"
                            value={formData.quantity}
                            onChange={handleCapacityChange}
                            placeholder="Cantidad"
                            className="form-input"
                            required
                        />
                    </div>
                </div>
                <div className="flex justify-center mt-4 gap-4">
                    <button
                        type="button"
                        onClick={onClose}
                        className="button-gray"
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="button-send"
                    >
                        Agregar
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default CapacityModal;
